import React, {useEffect, useState} from "react";
import Header from "../../../layout/header";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import NotFoundData from "../../../../Images/no-data-found.webp"
import {toast} from "react-toastify";
import CallLogsDetails from "../CallLogsDetails";
import Camera from "react-html5-camera-photo";

const FseInventory = ({
                         getInactiveFsesRequest,
                         tollById,
                         getInactiveFsesResponse = [],
                         tollView = [],
                         match,
                          getFseInventoryRequest,
                          getFseInventoryResponse = [],
                          callLogsResponse = [],
                          callLogsRequest,
                          tollPendingMeetingResponse = [],
                          tollPendingMeetingRequest,
                          documentUploadUrlPublic,
                          documentUrlDataPublic,
                          nearestPlazaFromOperatorLocationRequest,
                          nearestPlazaFromOperatorLocationResponse = []
                     }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [phoneNo, setPhoneNo] = useState(0);
    const [list, setList] = useState([]);
    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState(0);
    const [selfie, setSelfies] = useState([{}])
    const [isActiveScheduled, setIsActiveScheduled] = useState(false);

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            if(parseInt(window.localStorage.toll_id) !== parseInt(match?.params?.id)){
                delete window.localStorage.inactive_fse;
                delete window.localStorage.fse_inventory;
                delete window.localStorage.fse_tag_transfer;
                delete window.localStorage.penalty;
                delete window.localStorage.active_fse_percentage;
                delete window.localStorage.fse_inventory_percentage;
                delete window.localStorage.fse_tag_transfer_percentage;
                delete window.localStorage.penalty_percentage;
                delete window.localStorage.fse_tag_transfer_selfie;
                delete window.localStorage.penalty_selfie;
                delete window.localStorage.fse_inventory_selfie;
                delete window.localStorage.inactive_fse_selfie;
                delete window.localStorage.is_inactive_fse_tab;
                delete window.localStorage.fse_inventory_tab;
                delete window.localStorage.penalty_percentage_tab;
                delete window.localStorage.fse_tag_transfer_tab;
            }

            // window.localStorage.fse_inventory = [];
            window.localStorage.toll_id = match?.params?.id;
            window.localStorage.fse_inventory_tab = true;
            await tollById(match?.params?.id);
            await tollPendingMeetingRequest(match?.params?.id);
            setIsLoading(false);
        })();
    }, []);

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            if(tollView?.data?.latitude){
                await getInactiveFsesRequest(tollView?.data?.latitude, tollView?.data?.longitude, 'inventory');
            }
            setIsLoading(false);
        })();
    }, [tollView]);

    useEffect(() => {
        if(tollPendingMeetingResponse?.data && parseInt(tollPendingMeetingResponse?.data?.status)  === 1){
            // toast.warn("No meeting is scheduled on this toll");
            // setTimeout(() => {
            //     window.location.href='fast-tag-toll-list'
            // }, 1000)
            setIsActiveScheduled(true)
        }
    }, [tollPendingMeetingResponse]);


    const handleCheckActivation = async (ids, phone, i) => {
        setIsLoading(true)
        setPhoneNo(phone)
        setIndex(i)
        await getFseInventoryRequest(ids)
        setIsLoading(false)
    }

    useEffect(() => {
        if(getFseInventoryResponse?.data){
            toast.success("Inventory is given!")
            markFseActive()
            if(!selfie[index]){
                selfie[index] = {}
            }
            selfie[index]['is_inventory_given'] = true;
            selfie[index]['phone_no'] = phoneNo;
            window.localStorage.fse_inventory_selfie = JSON.stringify(selfie)
        } else if(getFseInventoryResponse?.data === false){
            toast.error("Inventory is not given!")
        }
    }, [getFseInventoryResponse]);

    useEffect(() => {
        if(getInactiveFsesResponse?.data && getInactiveFsesResponse?.data?.low_inventory_operator_list && getInactiveFsesResponse?.data?.low_inventory_operator_list.length > 0){
            setList(getInactiveFsesResponse?.data?.low_inventory_operator_list)
            if(window.localStorage.fse_inventory && JSON.parse(window.localStorage.fse_inventory).length > 0){
                setList(JSON.parse(window.localStorage.fse_inventory))
                if(window.localStorage.fse_inventory_selfie){
                    setSelfies(JSON.parse(window.localStorage.fse_inventory_selfie))
                }
            } else {
                window.localStorage.fse_inventory = JSON.stringify(getInactiveFsesResponse?.data?.low_inventory_operator_list)
                window.localStorage.fse_inventory_selfie = [];
            }
        } else if(getInactiveFsesResponse?.data && getInactiveFsesResponse?.data?.low_inventory_operator_list && getInactiveFsesResponse?.data?.low_inventory_operator_list.length === 0){
            if(window.localStorage.fse_inventory){
                let inventory = JSON.parse(window.localStorage.fse_inventory);
                if(inventory && Object.keys(inventory).length > 0){
                    setList(inventory)
                }
            } else {
                window.localStorage.fse_inventory = [];
                window.localStorage.fse_inventory_selfie = [];
            }
        } else if(getInactiveFsesResponse?.data === undefined && !window.localStorage.fse_inventory){
            window.localStorage.fse_inventory = [];
            window.localStorage.fse_inventory_selfie = [];
        }
    }, [getInactiveFsesResponse]);


    const checkNotAtToll = async (operatorId, plazaId, phoneNo, i) => {
        // const callLogs = await CallLogsDetails();
        setIsLoading(true);
        setPhoneNo(phoneNo)
        await nearestPlazaFromOperatorLocationRequest(operatorId, plazaId);
        setIsLoading(false);
        if(!selfie[i]){
            selfie[i] = {}
        }
        selfie[i]['not_at_toll'] = true;
        selfie[i]['phone_no'] = phoneNo;
        window.localStorage.fse_inventory_selfie = JSON.stringify(selfie)
        setSelfies(selfie)
        // if(callLogs.length > 0){
        //     let data = {call_log: callLogs, fse_phone_no: phoneNo}
        //     setIsLoading(true)
        //     await callLogsRequest(data)
        //     setIsLoading(false)
        // } else {
        //     toast.error("Need permission for call or you haven't not connected with fse!")
        // }
    }

    // const checkNotAtToll = async (phoneNo) => {
    //     const callLogs = await CallLogsDetails();
    //     if(callLogs.length > 0){
    //         let data = {call_log: callLogs, fse_phone_no: phoneNo}
    //         setIsLoading(true)
    //         setPhoneNo(phoneNo)
    //         await callLogsRequest(data)
    //         setIsLoading(false)
    //     } else {
    //         toast.error("Need permission for call or you haven't not connected with fse!")
    //     }
    // }

    useEffect(() => {
        if(parseInt(callLogsResponse?.status) === 200){
            markFseActive()
            toast.success("Action is saved!")
        } else if(parseInt(callLogsResponse?.status) !== 200){
            toast.error(callLogsResponse?.message)
        }
    }, [callLogsResponse]);

    const handleCloseConfirmationModal = () => setOpen(false);
    const handleOpenConfirmationModal = (index, phone_no) => {
        setOpen(true)
        setIndex(index)
        setPhoneNo(phone_no)
    }

    useEffect(() => {
        if(documentUrlDataPublic?.file_url){
            if(!selfie[index]){
                selfie[index] = {}
            }

            selfie[index]['selfie'] = documentUrlDataPublic?.file_url;
            selfie[index]['phone_no'] = phoneNo;
            // selfie[index]['is_kt_given'] = true;
            setSelfies(selfie)
            window.localStorage.fse_inventory_selfie = JSON.stringify(selfie)
        }
    }, [documentUrlDataPublic]);

    const markFseActive = (phone_no = '') => {
        let inventory = JSON.parse(window.localStorage.fse_inventory);
        let count = 0;
        let phone = phone_no ? phone_no : phoneNo;
        if(inventory){
            inventory.map((val, i) => {
                if(parseInt(val?.user_phone) === parseInt(phone)){
                    inventory[i]['is_active'] = true;
                }

                if(val?.is_active){
                    count++;
                }
            });
            window.localStorage.fse_inventory = JSON.stringify(inventory);
            window.localStorage.fse_inventory_percentage = (count  * 100) / inventory.length
            window.location.reload();
        }
    }

    const notMyFse = (phoneNo, i) => {
        setIsLoading(true);
        if(!selfie[i]){
            selfie[i] = {}
        }

        selfie[i]['not_my_fse'] = true;
        selfie[i]['phone_no'] = phoneNo;
        setSelfies(selfie)
        toast.success("Successfully marked");
        // setPhoneNo(phoneNo)
        markFseActive(phoneNo)
        window.localStorage.fse_inventory_selfie = JSON.stringify(selfie)
        setIsLoading(false);
    }

    useEffect(() => {
        // check call logs
        if(parseInt(nearestPlazaFromOperatorLocationResponse?.status) === 200){
            markFseActive()
            toast.success("Action is saved!")
        } else if(parseInt(nearestPlazaFromOperatorLocationResponse?.status) !== 200){
            toast.error(nearestPlazaFromOperatorLocationResponse?.message)
        }
    }, [nearestPlazaFromOperatorLocationResponse]);

    return (
        <>
            {open &&
                <>
                    <div className="modal fade" id="exampleModalCenter" tabIndex="-1" role="dialog"
                         aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLongTitle">Selfie</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true" onClick={() => {handleCloseConfirmationModal()}}>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {selfie[index]?.selfie ?
                                        <img alt="selfie"
                                             src={selfie[index]}/>
                                        :
                                        <Camera
                                            idealFacingMode={'user'}
                                            idealResolution={{
                                                width: 600,
                                                height: 480
                                            }}
                                            onTakePhoto={(dataUri) => {
                                                (async () => {
                                                    setIsLoading(true)
                                                    await documentUploadUrlPublic({ base_64_file: dataUri })
                                                    setIsLoading(false)
                                                })()
                                            }}
                                        />
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header title={"FSE Inventory"}/>
                        {/*BODY*/}
                        <div className="container-fluid common-bg">
                            {list.length > 0 &&
                                list.map((val, i) => {
                                    return (
                                        <>
                                            <div className="card">
                                                <div className="card-header" style={{
                                                    backgroundColor: "#473381",
                                                    color: "white"
                                                }}>{val?.user_name}</div>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="mb-0 bg-white">
                                                            <div className="card-body">
                                                                <div className="user">
                                                                    <div className="row">
                                                                        <div className="col-md-12 float-field ">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control form-control-user"
                                                                                value={
                                                                                    val?.user_phone
                                                                                }
                                                                            />
                                                                            <label className="large-label float-lb">
                                                                                Phone No:<i className=""></i>
                                                                            </label>
                                                                        </div>

                                                                        {isActiveScheduled &&
                                                                            <>
                                                                                <div className="col-md-12 float-field ">
                                                                                    <button
                                                                                        className={`${val?.is_active ? "btn btn-success" : "btn btn-primary"}`}
                                                                                        style={{width: "100%"}}
                                                                                        onClick={() => {
                                                                                            handleCheckActivation(val?.operator_id_list, val?.user_phone, 1)
                                                                                        }}
                                                                                        disabled={val?.is_active}>Check
                                                                                        Inventory
                                                                                    </button>
                                                                                </div>
                                                                                {selfie[i]?.selfie ?
                                                                                    <div
                                                                                        className="col-md-12 float-field mt-2">
                                                                                        <a href={selfie[i]?.selfie}
                                                                                           target="_blank"
                                                                                           className="btn btn-info"
                                                                                           style={{width: "100%"}}
                                                                                           data-dismiss="modal"
                                                                                           aria-label="Close">Selfie</a>
                                                                                    </div>
                                                                                    :
                                                                                    <div
                                                                                        className="col-md-12 float-field mt-2">
                                                                                        <button
                                                                                            className="btn btn-primary"
                                                                                            data-toggle="modal"
                                                                                            data-target="#exampleModalCenter"
                                                                                            style={{width: "100%"}}
                                                                                            onClick={() => {
                                                                                                handleOpenConfirmationModal(i, val?.user_phone)
                                                                                            }}
                                                                                            disabled={val?.is_active}
                                                                                        >Selfie
                                                                                        </button>
                                                                                    </div>
                                                                                }
                                                                                <div className="col-md-12 float-field ">
                                                                                    <button
                                                                                        className="btn btn-primary mt-2 text-center"
                                                                                        style={{width: "100%"}}
                                                                                        onClick={() => {
                                                                                            // checkNotAtToll(val?.user_phone)
                                                                                            checkNotAtToll(val?.operator_id_list[0], getInactiveFsesResponse?.data?.plaza_id, val?.user_phone, i)
                                                                                        }}
                                                                                        disabled={val?.is_active}>Check
                                                                                        FSE Not at Toll
                                                                                    </button>
                                                                                </div>
                                                                                <div className="col-md-12 float-field ">
                                                                                    <button
                                                                                        className="btn btn-primary mt-2 text-center"
                                                                                        style={{width: "100%"}}
                                                                                        onClick={() => {
                                                                                            notMyFse(val?.user_phone, i)
                                                                                            // checkNotAtToll(val?.user_phone)
                                                                                        }}
                                                                                        disabled={val?.is_active}
                                                                                    >Not My FSE
                                                                                    </button>
                                                                                </div>
                                                                            </>
                                                                        }

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )
                                })}
                            {list.length === 0 &&
                                <>
                                    <img src={NotFoundData} className="not-found-data" alt={""}/>
                                    <p className="text-center">Low inventory operator not found</p>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
};
export default FseInventory;
